// @flow
import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  setColumnWiseRoutes,
  toggleMenuBarDisplay
} from "../../commons/menuBar/menuBarRedux/menuBarActionCreator";

import { logout } from "../../../services/authService/authActionCreator";

import MenuBarWrapper from "../../commons/menuBar/menuBarWrapper";
import HeaderBar from "../../commons/headerBar/headerBar";
// import AlertsBar from "../../commons/alertsBar/alertsBar";

type Props = {
  // eslint-disable-next-line react/require-default-props
  userProfile: Object,
  setColumnWiseRoutes: Function,
  menuBarState: Object,
  toggleMenuBarDisplay: Function,
  logout: Function,
  pageState?: Object,
  history: Object
};

const HeaderWrapper = (props: Props) => (
  <div className="header_wrapper">
    <HeaderBar
      pageState={props.pageState}
      toggleMenuBarDisplay={props.toggleMenuBarDisplay}
      userProfile={props.userProfile}
      logout={props.logout}
    />
    <MenuBarWrapper
      history={props.history}
      userProfile={props.userProfile}
      setColumnWiseRoutes={props.setColumnWiseRoutes}
      menuBarState={props.menuBarState}
      toggleMenuBarDisplay={props.toggleMenuBarDisplay}
    />
    {
      // <AlertsBar />
      // <SearchBar />
    }
  </div>
);

HeaderWrapper.defaultProps = {
  pageState: {
    pageName: "",
    betaPage: false
  }
};

const mapStateToProps = state => ({
  userProfile: state.userProfile,
  menuBarState: state.menuBarState,
  pageState: state.pageState
});

const mapDispatchToProps = dispatch => ({
  setColumnWiseRoutes: bindActionCreators(setColumnWiseRoutes, dispatch),
  toggleMenuBarDisplay: bindActionCreators(toggleMenuBarDisplay, dispatch),
  logout: bindActionCreators(logout, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(HeaderWrapper);



// WEBPACK FOOTER //
// ./app/components/wrappers/headerWrapper/headerWrapper.js